export const getRandomProfileImageUrl = () => {
  return `https://api.dicebear.com/7.x/shapes/svg?seed=Loki`
}
